<template>
  <div>
    <pcg-btn size="small" @click="createNewNews" class="action-btn mr-3">{{ $t('views.news.news_new.save') }}</pcg-btn>
    <pcg-btn size="small" @click="createNewNews(true)" variant="additional" class="action-btn">{{ $t('views.news.news_new.save_draft') }}</pcg-btn>
    <abk-new-news-form class="form" v-model="form" :loading="loading" :submitted="submitted" :errors="errors" />
    <pcg-btn size="small" @click="createNewNews" class="action-btn mr-3">{{ $t('views.news.news_new.save') }}</pcg-btn>
    <pcg-btn size="small" @click="createNewNews(true)" variant="additional" class="action-btn">{{ $t('views.news.news_new.save_draft') }}</pcg-btn>
  </div>
</template>

<script>
import ApiWebpages from '../../api/webpages'
import AbkNewNewsForm from '../../components/AbkNewNewsForm'

export default {
  name: 'NewsNew',
  components: { AbkNewNewsForm },
  data () {
    return {
      errors: {},
      loading: false,
      submitted: false,
      form: {
        roles: ['student', 'graduate', 'career_office', 'employer', 'recruiter', 'public'],
        navigation: null,
        address: null,
        title: null,
        content: null,
        metaDescription: null,
        keywords: null,
        sort: 0,
        webpageType: 'news',
        forum: null,
        webpageAttachments: []
      }
    }
  },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.news.news_new.title'),
        subtitle: this.$t('views.news.news_new.subtitle')
      })
    },
    createNewNews (draft = false) {
      this.loading = true
      this.submitted = false
      const webpage = draft ? { ...this.form, status: 'draft' } : { ...this.form, status: 'published' }
      ApiWebpages.createWebpage({ webpage: webpage })
        .then(response => {
          this.errors = {}
          draft ? this.$router.push({ name: 'news_edit_path', params: { id: response.data.data.id } }) : this.$router.push({ name: 'news_path' })
        }).catch(error => {
          this.errors = error.response.data
          setTimeout(() => { this.$toastr.e(this.$t('general.check_errors')) }, 1)
        }).finally(() => {
          this.loading = false
          this.submitted = true
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/stylesheets/vars";

.action-btn {
  padding-left: 0;
  padding-right: 0;
  width: 150px;
  margin: 0;
}
.form {
  margin-top: $pcg-m-xxl;
}
</style>
